import React, { useState, useRef } from 'react'

import { INavStyles } from '../Navigation.types'
import { LoginMenuItems } from '../data/loginData'
import { Link } from 'gatsby'
import LoginNavItems from './LoginNavItems'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'

//MUI Components
import Menu from '@mui/material/Menu'
import CallToAction from '../../CallToAction'

const RightNavigationItems = ({ isAnimated }: INavStyles) => {
  const ref = useRef<HTMLDivElement>(null)
  const [anchorElement, setAnchorElement] = useState<HTMLButtonElement | null>(null)

  const setMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElement(event.currentTarget)
  }
  const setMenuClose = () => {
    setAnchorElement(null)
  }
  const theme = useTheme()
  const styles = {
    navLinks: {
      color: isAnimated ? theme.palette.common.black : theme.palette.common.white,
      cursor: 'pointer',
      fontWeight: 600,
      fontSize: '16px',
      textDecoration: 'none',
      whiteSpace: 'nowrap',
      display: 'inline-block',
      marginRight: '24px',
      '&:visited': {
        color: isAnimated ? theme.palette.common.black : theme.palette.common.white,
      },
      '&:hover, &:focus': {
        color: isAnimated ? theme.palette.primary.main : theme.palette.common.white,
      },
    },
    loginMenu: {
      marginTop: '16px',
      '& .MuiPaper-root': {
        boxShadow:
          '0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 5px 8px 0px rgb(0 0 0 / 14%), 0px 1px 14px 0px rgb(0 0 0 / 12%)',
        width: '287px',
      },
      '& .MuiList-root': {
        padding: '16px',
      },
    },
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Link style={styles.navLinks} to="/kundeservice" title="Find hjælp" data-id="cy-help">
        Find hjælp
      </Link>

      <Link style={styles.navLinks} to="/kundeservice/kontakt" title="Kontakt os" data-id="cy-kontakt">
        Kontakt os
      </Link>
      <CallToAction
        sx={{ padding: '12px 16px', whiteSpace: 'nowrap' }}
        id="login-button"
        data-testid="login-button"
        size="small"
        variant={!isAnimated ? 'invertedOutlined' : 'outlined'}
        aria-controls="selfservice-menu"
        aria-haspopup="true"
        onClick={setMenuOpen}
        buttonText={'Log ind'}
      />
      <Menu
        ref={ref}
        sx={styles.loginMenu}
        variant="menu"
        id="selfservice-menu"
        anchorEl={anchorElement}
        disableScrollLock
        keepMounted
        autoFocus
        open={Boolean(anchorElement)}
        onClose={setMenuClose}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        {LoginMenuItems.map((menuItem, index) => (
          <LoginNavItems key={index} {...menuItem} />
        ))}
      </Menu>
    </Box>
  )
}

export default RightNavigationItems
